import React, { useState } from "react";
import { Grid, TextField, Button, Divider, Container } from "@mui/material";

export default function Apuracao({
  keycloak,
  razaoSocial,
  cnpj,
  labelSolicitadoPor,labelSolicitadoPorCpfCnpj
}) {
  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Data Início: ${dataInicio} - Data Final: ${dataFinal}`);
  };

  const isFormValid = dataInicio !== "" && dataFinal !== "";

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label={labelSolicitadoPor}
              value={keycloak.tokenParsed.name}
              disabled
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label={labelSolicitadoPorCpfCnpj}
              value={keycloak.tokenParsed.preferred_username}
              disabled
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ margin: "20px" }} />
        </Grid>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Solicitado Para"
              value={razaoSocial}
              disabled
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField fullWidth label="CNPJ" value={cnpj} disabled />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ margin: "20px" }} />
        </Grid>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Data Início"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Data Final"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" type="submit" disabled={!isFormValid}>
              Enviar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
